<template>
  <el-dialog title="充值卡支付" :visible="visible" :show-close="false">
    <el-tabs v-model="activeTab" type="card" v-if="card.id == 0">
      <el-tab-pane label="卡号及密码" name="oldcard">
        <el-form :model="cardForm" :rules="cardFormRules" ref="cardForm" label-width="100px">
          <el-form-item label="卡号" prop="card_no">
            <el-input v-model="cardForm.card_no" style="width:194px;"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input type="password" v-model="cardForm.password" style="width:194px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="checkPassword">验证密码</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="读身份证" name="idcard">
        <el-button style="margin-left:100px;margin-top:50px;" type="success" @click="readIdcard">读取身份证</el-button>
      </el-tab-pane>
      <el-tab-pane label="验证手机号" name="phone">
        <el-form :model="phoneForm" :rules="phoneFormRules" ref="phoneForm" label-width="100px">
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="phoneForm.phone" style="width:300px;">
              <el-button slot="append" @click="sendVercode" :disabled="vercodeCountdown > 0">发送验证码{{ vercodeCountdown > 0 ? '(' + vercodeCountdown + ')' : ''}}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <el-input v-model="phoneForm.code" style="width:300px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="checkVercode">验证手机号</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <el-form :model="moneyForm" :rules="moneyFormRules" ref="moneyForm" label-width="200px" v-if="card.id > 0">
      <el-form-item label="充值卡卡号">
        {{ card.card_no }}
      </el-form-item>
      <el-form-item label="持卡人">
        {{ card.card_name }}
      </el-form-item>
      <el-form-item label="当前余额">
        {{ card.balance }}
      </el-form-item>
      <el-form-item label="本次支付" prop="money">
        <el-input v-model.number="moneyForm.money"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="commit" :loading="commiting" :disabled="commiting">确定支付</el-button>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    type: {
      type: String,
      default: 'bill'
    },
    billId: {
      type: Number,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    fee: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      vercodeCountdown: 0,
      activeTab: 'oldcard',
      phoneForm: {
        phone: '',
        code: ''
      },
      phoneFormRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      cardForm: {
        card_no: '',
        password: ''
      },
      cardFormRules: {
        card_no: [
          { required: true, message: '请输入卡号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      card: {
        id: 0,
        card_no: '',
        card_name: '',
        phone: '',
        balance: 0
      },
      moneyForm: {
        money: 0
      },
      moneyFormRules: {
        money: [
          {
            validator: (rule, value, callback) => {
              if (value === '' || value === '0' || value === 0) {
                callback(new Error('请输入支付金额'))
              } else if (value > this.card.balance) {
                callback(new Error('支付金额不能大于当前余额'))
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      },
      countdownTimer: false,
      idcardReading: false,
      commiting: false
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.phoneForm.phone = ''
        this.phoneForm.code = ''
        this.card.id = 0
        this.card.card_no = ''
        this.card.card_name = ''
        this.card.phone = ''
        this.card.balance = 0
      }
    },
    fee (val) {
      if (val) {
        this.moneyForm.money = val
      }
    }
  },
  mounted () {
    this.countdownTimer = setInterval(() => {
      if (this.vercodeCountdown > 0) {
        this.vercodeCountdown = this.vercodeCountdown - 1
      }
    }, 1000)
  },
  beforeDestroy () {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
    }
  },
  methods: {
    sendVercode () {
      if (this.phoneForm.phone.length != 11) {
        this.$message({
          type: 'error',
          message: '手机号格式错误'
        })
        return
      }
      this.$http.get('/dbapi/card_info?phone=' + this.phoneForm.phone).then(response => {
        if (response.data.success) {
          if (response.data.list.length === 0) {
            this.$message({
              type: 'error',
              message: '没有找到该手机号对应的充值卡'
            })
          } else {
            // this.card = response.data.list[0]
            this.$http.post('/api/sms_ver_code', {
              phone: this.phoneForm.phone,
              tempcode: 'SMS_126354863'
            }).then(response => {
              if (response.data.success) {
                this.vercodeCountdown = 60
                this.$message({
                  type: 'success',
                  message: '短信验证码已发送,请持卡人注意查收'
                })
              } else {
                this.$message({
                  type: 'error',
                  message: response.data.message
                })
              }
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      })
    },
    checkVercode () {
      this.$refs.phoneForm.validate((valid) => {
        if (valid) {
          this.$http.get(`/api/check_ver_code?phone=${this.phoneForm.phone}&code=${this.phoneForm.code}`).then(response => {
            if (response.data.success) {
              return this.$http.get('/dbapi/card_info?phone=' + this.phoneForm.phone)
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          }).then(response => {
            if (response.data.success && response.data.list.length > 0) {
              this.card = response.data.list[0]
              this.phoneForm.phone = ''
              this.phoneForm.code = ''
            }
          })
        }
      })
    },
    checkPassword () {
      this.$refs.cardForm.validate((valid) => {
        if (valid) {
          this.$http.get(`/dbapi/card_info?card_no=${this.cardForm.card_no}&password=${this.cardForm.password}`).then(response => {
            if (response.data.success) {
              if (response.data.list.length > 0) {
                this.card = response.data.list[0]
                this.cardForm.card_no = ''
                this.cardForm.password = ''
              } else {
                this.$message({
                  type: 'error',
                  message: '卡号或密码错误'
                })
              }
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      })
    },
    readIdcard () {
      if (this.idcardReading) {
        return
      }
      this.idcardReading = true
      this.$idcard.read().then(data => {
        return this.$http.get('/dbapi/card_info?card_no=' + data.code)
      }).then(response => {
        this.idcardReading = false
        if (response.data.success && response.data.list.length > 0) {
          this.card = response.data.list[0]
        } else {
          this.$message({
            type: 'error',
            message: response.data.message || '没有找到该充值卡'
          })
        }
      }).catch(() => {
        this.idcardReading = false
      })
    },
    commit: _.throttle(
      function () {
        this.commiting = true
        this.$refs.moneyForm.validate((valid) => {
          if (valid) {
            if (this.type != 'space_bill') {
              this.$http.post('/dbapi/add_pay_balance', {
                id: this.billId,
                money: this.moneyForm.money,
                card_no: this.card.card_no
              }).then(response => {
                this.commiting = false
                this.$emit('commit')
              })
            } else {
              this.$http.post('/dbapi/add_pay_balance_sb', {
                id: this.billId,
                money: this.moneyForm.money,
                card_no: this.card.card_no
              }).then(response => {
                this.commiting = false
                this.$emit('commit', this.moneyForm.money)
              })
            }
          }
        })
      },
      5000
    ),
    close () {
      this.$emit('cancel')
    }
  }
}
</script>

<style>
.pay-form .el-form-item {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/rent/PayCardDialog.vue